import { useDispatch, useSelector } from 'react-redux';
import { Icon } from '@iconify/react';
import { deleteInvestment } from '../../../../redux/actions/SocietyPortal/InvestmentAction/InvestmentAction';
import { selectedSocietyStorer } from '../../../../utils/webStorer';

const formatCurrency = (amount) =>
    parseFloat(amount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const InvestmentDeleteModal = ({ investment, onClose, onSuccess }) => {
    const dispatch = useDispatch();
    const societyId = selectedSocietyStorer.getSocietyId();
    const { deleteLoading } = useSelector(state => state.InvestmentReducer || {});

    const handleConfirm = () => {
        dispatch(deleteInvestment({
            societyId,
            id: investment.id,
            onSuccess: () => onSuccess?.(),
        }));
    };

    if (!investment) return null;

    return (
        <div className="tw-fixed tw-inset-0 tw-z-50 tw-flex tw-items-center tw-justify-center tw-bg-black/40" onClick={onClose}>
            <div
                className="tw-bg-white tw-rounded-xl tw-shadow-xl tw-w-full tw-max-w-md tw-mx-4 tw-overflow-hidden"
                onClick={(e) => e.stopPropagation()}
            >
                {/* Header */}
                <div className="tw-flex tw-items-start tw-gap-3 tw-p-5 tw-border-b tw-border-gray-100">
                    <div className="tw-w-10 tw-h-10 tw-rounded-full tw-bg-red-50 tw-flex tw-items-center tw-justify-center tw-flex-shrink-0">
                        <Icon icon="mdi:alert-circle-outline" className="tw-text-red-500 tw-text-xl" />
                    </div>
                    <div className="tw-flex-1">
                        <h2 className="tw-text-sm tw-font-bold tw-text-gray-800">Delete Investment?</h2>
                        <p className="tw-text-xs tw-text-gray-500 tw-mt-1">
                            This action cannot be undone. The investment will be soft-deleted and removed from the active list.
                        </p>
                    </div>
                    <button onClick={onClose} className="tw-p-1 tw-rounded hover:tw-bg-gray-100 tw-text-gray-400">
                        <Icon icon="mdi:close" className="tw-text-base" />
                    </button>
                </div>

                {/* Investment Summary */}
                <div className="tw-p-5">
                    <div className="tw-bg-gradient-to-br tw-from-red-50/50 tw-to-rose-50/50 tw-border tw-border-red-100 tw-rounded-lg tw-p-3">
                        <div className="tw-flex tw-items-center tw-justify-between tw-mb-2 tw-pb-2 tw-border-b tw-border-red-100/60">
                            <span className="tw-text-[10px] tw-uppercase tw-font-semibold tw-text-red-600 tw-tracking-wide">FD Number</span>
                            <span className="tw-text-xs tw-font-bold tw-text-gray-800 tw-font-mono">{investment.investment_number}</span>
                        </div>
                        <div className="tw-grid tw-grid-cols-2 tw-gap-3">
                            <div>
                                <p className="tw-text-[10px] tw-text-gray-500 tw-uppercase tw-tracking-wide">Principal</p>
                                <p className="tw-text-xs tw-font-semibold tw-text-gray-800 tw-mt-0.5">₹{formatCurrency(investment.principal_amount)}</p>
                            </div>
                            <div>
                                <p className="tw-text-[10px] tw-text-gray-500 tw-uppercase tw-tracking-wide">Rate</p>
                                <p className="tw-text-xs tw-font-semibold tw-text-gray-800 tw-mt-0.5">{parseFloat(investment.interest_rate || 0).toFixed(2)}%</p>
                            </div>
                            <div>
                                <p className="tw-text-[10px] tw-text-gray-500 tw-uppercase tw-tracking-wide">Investment Date</p>
                                <p className="tw-text-xs tw-font-semibold tw-text-gray-800 tw-mt-0.5">{investment.investment_date}</p>
                            </div>
                            <div>
                                <p className="tw-text-[10px] tw-text-gray-500 tw-uppercase tw-tracking-wide">Maturity Date</p>
                                <p className="tw-text-xs tw-font-semibold tw-text-gray-800 tw-mt-0.5">{investment.maturity_date}</p>
                            </div>
                        </div>
                    </div>

                    <div className="tw-flex tw-items-start tw-gap-2 tw-mt-3 tw-text-[11px] tw-text-amber-700 tw-bg-amber-50 tw-border tw-border-amber-100 tw-rounded-md tw-p-2">
                        <Icon icon="mdi:information-outline" className="tw-text-sm tw-flex-shrink-0 tw-mt-0.5" />
                        <span>Investments with collected interest or reconciled journal entries cannot be deleted.</span>
                    </div>
                </div>

                {/* Footer */}
                <div className="tw-flex tw-items-center tw-justify-end tw-gap-2 tw-px-5 tw-py-3 tw-border-t tw-border-gray-100 tw-bg-gray-50">
                    <button
                        type="button"
                        onClick={onClose}
                        disabled={deleteLoading}
                        className="tw-px-4 tw-py-1.5 tw-rounded-md tw-text-xs tw-font-medium tw-text-gray-700 tw-bg-white tw-border tw-border-gray-200 hover:tw-bg-gray-50 disabled:tw-opacity-50"
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        onClick={handleConfirm}
                        disabled={deleteLoading}
                        className="tw-flex tw-items-center tw-gap-1 tw-px-4 tw-py-1.5 tw-rounded-md tw-text-xs tw-font-medium tw-text-white tw-bg-red-600 hover:tw-bg-red-700 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
                    >
                        {deleteLoading
                            ? <div className="tw-animate-spin tw-rounded-full tw-h-3 tw-w-3 tw-border-2 tw-border-white tw-border-t-transparent"></div>
                            : <Icon icon="mdi:trash-can-outline" className="tw-text-sm" />}
                        Delete Investment
                    </button>
                </div>
            </div>
        </div>
    );
};

export default InvestmentDeleteModal;
